export default __webpack_public_path__ + "img/business-homepage.a90edb44.svg";